<nav class="toolbar navbar navbar-light">
    <form class="form-inline" autocomplete="off">
        <!--<button class="btnback btn btn-outline-success"><i class="fa fa-chevron-left"></i></button>-->
        <button class="btn btn-outline-success" type="button" (click)="onAdd()"><i class="fa fa-file-o"></i> Nuevo </button>
        <button *ngIf="!visibilitySpinner" type="button" class="btn btn-outline-success" (click)="onExportExcel()"><i class="fa fa-file-excel-o"></i> Exportar </button>
        <button *ngIf="visibilitySpinner" type="button" [disabled]="true" class="btn btn-outline-success">
            <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
            Exportando
        </button>
    </form>
</nav>

<form [formGroup]="form" class="container-fluid" autocomplete="off">
    <div class="animated fadeIn">

        <div class="row">
            <div class="col-md-12">
                <h4>Buscador de Países</h4>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">

                    <a class="card-header-a" (click)="isCollapsed = !isCollapsed"
                       [attr.aria-expanded]="!isCollapsed" aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-filter"></i> Filtros
                            <i *ngIf="isCollapsed" class="fa fa-caret-down float-right"></i>
                            <i *ngIf="!isCollapsed" class="fa fa-caret-up float-right"></i>
                        </div>
                    </a>
                    <div class="card-body">

                        <!-- Ocultamos solo los campos, para que estén siempre visibles los botones "Buscar y Limpiar" -->
                        <div class="collapse group-filtros" id="collapseFiltros" [ngbCollapse]="isCollapsed">

                            <div class="row">

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpPais">Nombre País</label>
                                    <input formControlName="Descripcion" name="Descripcion" maxlength="50" title=""
                                           class="form-control" id="inpDescripcion" type="text" value="">
                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpDescripcion">Nombre País (Inglés)</label>
                                    <input formControlName="DescripcionIngles" name="DescripcionIngles" title=""
                                           maxlength="300" class="form-control" id="inpDescripcionIngles" type="text" value="">
                                </div>

                                <div class="form-group col-md-2">
                                    <label class="col-form-label" for="inpDescripcion">Convenio ISO</label>
                                    <input formControlName="ConvenioIso" name="ConvenioIso" title="" maxlength="2"
                                           class="form-control" id="inpConvenio" type="text" value="">
                                </div>

                                <div class="form-group col-md-2">
                                    <label class="col-form-label" for="inpDescripcion">Convenio ISO Traces</label>
                                    <input formControlName="ConvenioIsoTraces" name="ConvenioIsoTraces" title="" maxlength="2"
                                           class="form-control" id="inpConvenio" type="text" value="">
                                </div>

                            </div>

                            <div class="row">

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpPreDua">Habilitado</label>
                                    <p-selectButton class="selectButtonCust"
                                                    [options]="listSiNoTodos"
                                                    formControlName="Habilitado"
                                                    unselectable="true">
                                    </p-selectButton>
                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpUsaCodigoPostal">Usa Código Postal</label>
                                    <p-selectButton class="selectButtonCust"
                                                    [options]="listSiNoTodos"
                                                    formControlName="UsaCodigoPostal"
                                                    unselectable="true">
                                    </p-selectButton>
                                </div>

                                <div class="form-group col-md-4">
                                    <label class="col-form-label" for="inpePhytoCanReceive">ePhyto</label>
                                    <p-selectButton class="selectButtonCust"
                                                    [options]="listSiNoTodos"
                                                    formControlName="EPhytoCanReceive"
                                                    unselectable="true">
                                    </p-selectButton>
                                </div>

                            </div>

                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group-0 float-right">

                                    <div class="btn-group">
                                        <button name="btnSearch" class="btn btn-secondary btn-sm" type="submit" title="Realiza una búsqueda" (click)="onSearchButton()"><i class="fa fa-search"></i> Buscar</button>
                                    </div>

                                    <div class="btn-group">
                                        <button class="btn btn-secondary btn-sm" type="button" title="Limpia los filtros" (click)="onCleanButton()"><i class="fa fa-eraser"></i> Limpiar</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>


        <!--DATAGRID-->

        <div *ngIf="searchingButton" class="row">
            <div class="col-md-12">
                <div class="card card-accent-success">
                    <div class="card-header-buscador">
                        <i class="fa fa-align-justify"></i> Listado de Países
                    </div>

                    <div class="card-body-grid">

                        <p-table #tableSearch autoLayout="true" [value]="resultPais.ResultList" [lazy]="true" (onLazyLoad)="onSearchLazy($event)" [paginator]="true"
                                 [columns]="cols" sortField="Descripcion" [rows]="resultPais?.PageSize" [totalRecords]="resultPais.TotalCount" [loading]="loading"
                                 styleClass="table table-responsive-sm  table-striped table-sm"
                                 [ngClass]="displayGridHidden(resultPais.ResultList)">
                            <ng-template pTemplate="header" let-columns>
                                <tr>
                                    <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display':col.display}" [pSortableColumn]="col.field">
                                        {{col.header}}
                                        <p-sortIcon *ngIf="col.field!=='Link'" [field]="col.field"></p-sortIcon>
                                    </th>

                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
                                <tr>
                                    <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                        <span *ngIf="col.field!=='Link' && col.field!=='Habilitado' && col.field!=='UsaCodigoPostal'  && col.field!=='EPhytoCanReceive'">{{rowData[col.field]}}</span>
                                        <span *ngIf="col.field==='UsaCodigoPostal'">{{rowData[col.field] | siNo}}</span>
                                        <span *ngIf="col.field==='Habilitado'">{{rowData[col.field] | siNo}}</span>
                                        <span *ngIf="col.field==='EPhytoCanReceive'">{{rowData[col.field] | siNo}}</span>
                                        <div *ngIf="col.field==='Link'" class="btn-group">
                                            <button (click)="onEdit(rowData)" type="button" title="Editar"
                                                    class="btn btn-sm btn-warning">
                                                <span class="fa fa-edit"></span>
                                            </button>
                                            <button (click)="onDelete(rowData)" type="button" title="Eliminar"
                                                    class="btn btn-sm btn-danger">
                                                <span class="fa fa-remove"></span>
                                            </button>
                                        </div>
                                    </td>
                                </tr>

                            </ng-template>
                        </p-table>

                        <div class="p-2" *ngIf="tableSearch.totalRecords">Se han encontrado {{ tableSearch.totalRecords  | number:'1.0-0':'es-ES' }} registros</div>
                        <div class="empty-grid" *ngIf="tableSearch.totalRecords === 0">No se ha encontrado ningún registro</div>
                    </div>

                </div>
            </div>
        </div>
    </div>

</form>
